import React from 'react';
import PropTypes from "prop-types";

import RadioButton from 'components/radioButton/radioButton';
import styles from './radioGroup.scss';

function RadioGroup(props) {

    const { options, value, getKey, getName, onChange, onBlur, radioGroupContainerClass, ...otherProps } = props;

    const renderOption = (option) => (
        <RadioButton
            key={getKey(option)}
            checked={getKey(value) === getKey(option)}
            onChange={() => onChange(option)}
            onBlur={onBlur}
            radioButtonContainerClass={styles.radioContainer}
            {...otherProps}
        >
            <span>{getName(option)}</span>
        </RadioButton>
    )

    return (
        options && options.length > 0 ? <div className={radioGroupContainerClass}>{options.map(renderOption)}</div> : null
    )
}

RadioGroup.defaultProps = {
    getKey: option => option.id,
    getName: option => option.displayName,
    radioGroupContainerClass: "b2b-lib-radioGroupContainer"
}

RadioGroup.propTypes = {
    options: PropTypes.array,
    value: PropTypes.object,
    getKey: PropTypes.func,
    getName: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    radioGroupContainerClass: PropTypes.string
}

export default RadioGroup
